import ResultItem from './ResultItem';

export default ResultItem;
